export default {
    center: {
        type: Array,
        default: undefined
    }, 
    controls: {
        type: Object,
        default: undefined
    }, 
    layerDefaults: {
        type: Object,
        default: undefined
    }, 
    layers: {
        type: Array,
        default: undefined
    }, 
    markerDefaults: {
        type: Object,
        default: undefined
    }, 
    markers: {
        type: Array,
        default: undefined
    }, 
    minZoom: {
        type: Number,
        default: undefined
    }, 
    maxZoom: {
        type: Number,
        default: undefined
    }, 
    minSize: {
        type: Number,
        default: undefined
    }, 
    pannable: {
        type: Boolean,
        default: undefined
    }, 
    wraparound: {
        type: Boolean,
        default: undefined
    }, 
    zoom: {
        type: Number,
        default: undefined
    }, 
    zoomable: {
        type: Boolean,
        default: undefined
    }, 

    // Events
    beforeReset: {
        type: Function,
        default: undefined
    },  
    click: {
        type: Function,
        default: undefined
    },  
    markerActivate: {
        type: Function,
        default: undefined
    },  
    markerCreated: {
        type: Function,
        default: undefined
    },  
    markerClick: {
        type: Function,
        default: undefined
    },  
    pan: {
        type: Function,
        default: undefined
    },  
    panEnd: {
        type: Function,
        default: undefined
    },  
    reset: {
        type: Function,
        default: undefined
    },  
    shapeClick: {
        type: Function,
        default: undefined
    },  
    shapeCreated: {
        type: Function,
        default: undefined
    },  
    shapeFeatureCreated: {
        type: Function,
        default: undefined
    },  
    shapeMouseEnter: {
        type: Function,
        default: undefined
    },  
    shapeMouseLeave: {
        type: Function,
        default: undefined
    },  
    zoomStart: {
        type: Function,
        default: undefined
    },  
    zoomEnd: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/MapProps.js